// LIBS
import React from 'react'

// HELPERS
import {renderIf} from '../../lib/util.js'
// required for the clipping of the description
import Shiitake from 'shiitake'
const defaultImage = 'https://images.ctfassets.net/k428n7s2pxlu/1o6PhW35WMKKO6eyy8Yma8/891420f8777d6d0bbbb1635a5615d732/clement-h-544786-unsplash-square.jpg'

// INTERFACE
class EventCalendarItem extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      smallScreen: false,
    };
    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  componentDidMount(){
    if (typeof window !== 'undefined'){
      window.addEventListener('resize', this.handleWindowResize);
    }
  }
  componentWillUnmount(){
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }
  handleWindowResize(){
    this.setState({ smallScreen: window.innerWidth < 700 })
  }

  render () {
    const {
      eventImage,
      title,
      location,
      signup_url,
      formatted_date,
      start_time,
      end_time,
      description
    } = this.props.event;
    
    const fullTimeString = `${start_time} ${end_time ? `– ${end_time}` : ''}`
    
return (
      <article itemScope itemType='http://shchema.org/Event' className="calendar-event cf event-calendar-item"> 
        <div className='event-image-container'>
          <img className='event-image' src={eventImage || defaultImage} />
        </div>
        <div className='details'> 
          <header>
            <h1 itemProp='name'>{title}</h1>
            <h2 itemProp='startDate'>{formatted_date}</h2>
            <h2 itemProp='doorTime' content={start_time}>{fullTimeString} </h2>
            <h2 itemProp='location'>{location}</h2>        
          </header>

          {/* WARNING DONT ALLOW ANY SPACES TO SURROUND {description} it will break Shiitake */}
          {renderIf(this.state.smallScreen, <Shiitake lines={4} tagName='p' itemProp='description'>{description}</Shiitake>)}
          {renderIf(!this.state.smallScreen, <Shiitake lines={2} tagName='p' itemProp='description'>{description}</Shiitake>)}
  
          <div className="action-buttons">
            <a itemProp='url' href={signup_url} target="_blank">RSVP</a>
          </div>
        </div>
      </article>
    );
  }  
  }

export default EventCalendarItem



// WEBPACK FOOTER //
// ./src/components/event-calendar-item/index.js